// extracted by mini-css-extract-plugin
module.exports = {"OrdersListTable":"styles_OrdersListTable__3DAOP","OrdersListTableHeader":"styles_OrdersListTableHeader__i_e43","OrdersListTableBody":"styles_OrdersListTableBody__3Amqr"};